import { Reveal, Chapter } from "./Reveal";

const ITEMS = [
  {
    label: "Review Stand",
    src: "/assets/google-nfc-stand-cutout.png",
    alt: "White freestanding NFC review stand with Google logo, five stars and 'Review Us On Google' print",
  },
  {
    label: "Stand — Back",
    src: "/assets/google-nfc-stand-back-cutout.png",
    alt: "Blank back view of the white freestanding NFC review stand",
  },
  {
    label: "Review Plate",
    src: "/assets/product-plate.png",
    alt: "Flat white NFC review plate with Google logo, five stars and 'Tap your phone' print",
  },
  {
    label: "Handheld Card",
    src: "/assets/product-card.png",
    alt: "Handheld white NFC review card with Google logo, five stars and 'Tap your phone' print",
  },
];

export const Gallery = () => (
  <section className="bg-white py-28 sm:py-36 overflow-hidden" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-6">
      <Chapter number="01" label="The Card" />
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
        <Reveal>
          <h2 className="rvr-title font-display text-4xl md:text-5xl font-bold tracking-tight text-ink leading-[1.05] max-w-xl">
            A physical product, made to be seen
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-black/55 max-w-sm text-sm leading-relaxed">
            Stands, plates and handheld cards — consistent finish and print, each one configured
            for your business before it ships.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {ITEMS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div
              data-testid={`gallery-item-${i}`}
              className="group relative aspect-[3/4] overflow-hidden rounded-sm bg-mist border border-black/5 flex items-center justify-center"
            >
              <img
                src={s.src}
                alt={s.alt}
                loading="lazy"
                className="w-4/5 h-auto object-contain [filter:drop-shadow(0_24px_30px_rgba(10,10,10,0.18))] group-hover:scale-[1.04] group-hover:-translate-y-1 transition-transform duration-500"
              />
              <div className="absolute bottom-0 inset-x-0 p-4">
                <p className="text-black/45 text-xs font-bold tracking-[0.15em] uppercase">{s.label}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
